import { Typography } from "@material-ui/core";
import React from "react";

export const dependentRatesRenderer = (value) => {
    return (
        <>
            {value?.length > 0 ? (
                value?.map((item, itemIdx) => (
                    <Typography key={`inheritedRate: ${itemIdx}`}>
                        {item.name}
                    </Typography>
                ))
            ) : (
                <Typography>Нет наследованных тарифов</Typography>
            )}
        </>
    );
};
